
import React from "react";

function ToolTip({ data, isShow, position, color }) {
  const top = position.top + window.pageYOffset + data.y;
  const left = position.left + window.pageXOffset + data.x;

  return (
    isShow && (
      <div style={{ top, left, color }} className="tooltip-wrapper">
        {data.yLabel}
      </div>
    )
  );
}

export default ToolTip;
// padding: 10px 20px;
// border-radius: 5px;
// box-shadow: 0 10px 24px 0 rgba(29, 42, 68, 0.12);
// background-color: #fff;
// position: absolute;